import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class CustomCheckbox extends React.Component {
  static propTypes = {
    keyName: PropTypes.any,
    style: PropTypes.object,
    checked: PropTypes.any,
    isDisabled: PropTypes.any,
    handleChange: PropTypes.any,
    handleClick: PropTypes.any,
    classes: PropTypes.any
  };

  render() {
    let { keyName, checked, isDisabled, handleChange, handleClick, classes } = this.props;
    return (
      <div className={`custom-checkbox ${classes}`}>
        <input
          key={keyName}
          type="checkbox"
          className="input-checkbox"
          checked={checked}
          disabled={isDisabled}
          onChange={handleChange}
        />
        <span className={`check-${checked}`} onClick={handleClick}></span>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomCheckbox);
